export const en = {
    'error-refresh': 'An error has occurred. Try refreshing the page.'
};
